import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { State } from './types';

const initialState: State = {
  parties: [],
  history: [],
};

export default createSlice({
  name: 'turnTracking',
  initialState,
  selectors: {
    parties: (state) => state.parties,
    history: (state) => state.history,
  },
  reducers: {
    reset: () => initialState,
    setHistory: (state: State, action: PayloadAction<State['history']>) => {
      state.history = action.payload;
    },
    setParties: (state: State, action: PayloadAction<State['parties']>) => {
      state.parties = action.payload;
    },
  },
});
